export const sampleDigestStats = {
  errors: {
    group_count: { previous: 10, current: 10 },
    group_count_trend: null as string,
    notice_count: { previous: 64, current: 69 },
    notice_count_trend: "↑8",
  },
  deploys: {
    deploy_count: { previous: 9, current: 8 },
    deploy_count_trend: "↓11",
  },
  performance: {
    request_count: { previous: 1080, current: 459 },
    request_count_trend: "↓57",
    request_rate: { previous: 0.10714284285714, current: 0.0455355714284 },
    request_rate_trend: "↓58",
    p50: { previous: 271.93, current: 352.454 },
    p50_trend: "↑30",
    p95: { previous: 3917.319, current: 3700.083 },
    p95_trend: "↓6",
    error_rate: { previous: 3.425925925926, current: 8.714596991067 },
    error_rate_trend: "↑154",
    apdex_threshold: { previous: 0.5, current: 0.5 },
    apdex_score: { previous: 0.97, current: 0.94 },
    apdex_score_trend: "↓3",
  },
};
